import { Component, HostBinding, OnInit } from '@angular/core';

@Component({
    selector: 'app-subtenant-management',
    templateUrl: './subtenant-management.component.html',
    styleUrls: ['./subtenant-management.component.scss']
})
export class SubtenantManagementComponent implements OnInit
{
    @HostBinding('class') classes = 'bg mat-typography';
    constructor() { }

    ngOnInit(): void
    {
    }

}
